import { render } from "./VideoTrailer.vue?vue&type=template&id=5f834235&scoped=true"
import script from "./VideoTrailer.vue?vue&type=script&lang=js"
export * from "./VideoTrailer.vue?vue&type=script&lang=js"

import "./VideoTrailer.vue?vue&type=style&index=0&id=5f834235&lang=sass&scoped=true"
import "./VideoTrailer.vue?vue&type=style&index=1&id=5f834235&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f834235"]])

export default __exports__